import ChoosePaymentMethodModal from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/MembershipTab/components/PaymentMethodsSection/components/PaymentMethods/components/ChoosePaymentMethodModal/ChoosePaymentMethodModal';

import { AddAchModal } from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/MembershipTab/components/PaymentMethodsSection/components/PaymentMethods/components/AddAchModal';
import { AddAchModal as AddAchModalNonDea } from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/PaymentsTab/components/PaymentMethods/components/AddAchModal';
import { AddCcModal as AddCcModalNonDea } from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/PaymentsTab/components/PaymentMethods/components/AddCcModal';
import usePaymentMethodsStore from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/MembershipTab/components/PaymentMethodsSection/components/PaymentMethods/hooks/usePaymentMethodsStore';
import { AddCcModal } from '~/modules/contact/components/ContactDetails/components/TabsContainer/components/MembershipTab/components/PaymentMethodsSection/components/PaymentMethods/components/AddCcModal';
import { useLocationContext } from '~/contexts/location.context';
import { useGetIds } from '~/modules/auth';
import { useMemo } from 'react';

export default function AddPaymentMethodModal() {
  const { locationId, isDea } = useLocationContext();
  const { memberId } = useGetIds();

  const {
    isOpen,
    close,
    clean,
    openAddCC,
    openAddACH,
    isAddCCOpen,
    isAddACHOpen,
    memberId: preSelectedMemberId,
  } = usePaymentMethodsStore();

  const handleModalClose = () => {
    clean();
  };

  const handleModalNext = (paymentType: string) => {
    close();

    if (paymentType === 'cc') {
      openAddCC();
    } else {
      openAddACH();
    }
  };

  const actualMemberId = useMemo(() => {
    if (memberId) return memberId;
    return preSelectedMemberId;
  }, [memberId, preSelectedMemberId]);

  return (
    <>
      {isOpen && (
        <ChoosePaymentMethodModal
          addPaymentMethodOpen={isOpen}
          handleModalNext={handleModalNext}
          handleModalClose={handleModalClose}
          memberId={actualMemberId}
        />
      )}
      {isAddCCOpen && isDea && (
        <AddCcModal
          addCCOpen={isAddCCOpen}
          handleModalClose={handleModalClose}
          memberId={actualMemberId}
          locationId={locationId}
        />
      )}
      {isAddACHOpen && isDea && (
        <AddAchModal
          addAchOpen={isAddACHOpen}
          handleModalClose={handleModalClose}
          memberId={actualMemberId}
          locationId={locationId}
        />
      )}

      {isAddCCOpen && !isDea && (
        <AddCcModalNonDea
          addCCOpen={isAddCCOpen}
          handleModalClose={handleModalClose}
          memberId={actualMemberId}
          locationId={locationId}
        />
      )}
      {isAddACHOpen && !isDea && (
        <AddAchModalNonDea
          addAchOpen={isAddACHOpen}
          handleModalClose={handleModalClose}
          memberId={actualMemberId}
          locationId={locationId}
        />
      )}
    </>
  );
}
